import initCartHandler from './hooks/cart';
import initButtonHandler from './hooks/cartButton';

export default function setupShopifyCartHook() {
  initCartHandler();
  initButtonHandler();
}
